module.exports = __webpack_public_path__ + "static/media/face_nosmile.1f2bedc0.svg";